import React from "react";
import moment from "moment";
import "moment/locale/ko";
import { SHA256, enc, AES } from "crypto-js";
// import { FEE } from "constants/index";

export function numberWithCommas(number) {
  if (
    number === "" ||
    number === null ||
    number === "null" ||
    number === undefined
  ) {
    return "";
  }
  if (isNaN(number)) {
    return number;
  }
  var parts = (+number).toString().split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return parts.join(".");
}

export function dateToString(date = new Date(), format = "YYYY-MM-DD") {
  return moment(date).format(format);
}

// // 수수료 제외 주문 총액
// export function getPrice(point = 0) {
//   return Math.floor(point / (1 + FEE));
// }

// // 수수료
// export function getFee(point = 0) {
//   return point - getPrice(point);
// }

export function newLineText(str) {
  return str.split("\n").map((line, i) => {
    return (
      <span key={i}>
        {line}
        <br />
      </span>
    );
  });
}

export function goFullWebView(payload) {
  if (!window.wallet) {
    return;
  }
  if (payload) {
    let params = payload;
    if (params.url) {
      params.url =
        (process.env.REACT_APP_SYRUP_SERVER_BASE || "") +
        process.env.PUBLIC_URL +
        params.url;
    }
    window.wallet.goFullWebView(JSON.stringify(params));
  }
}

export function isEmpty(obj) {
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      return false;
    }
  }
  return true;
}

export function cengoldAlert(messageObj) {
  if (!window.wallet) {
    return;
  }
  const { h1, tt, btnConfirm } = messageObj;
  window.wallet.openPopup(
    JSON.stringify({
      popupType: "basic",
      title: h1,
      message: tt,
      buttons: [
        { buttonText: "취소", callbackJS: "" },
        { buttonText: btnConfirm, callbackJS: "mainComp.actionAppCengold" },
      ],
    })
  );
}

export function actionAppCengold() {
  const androidUrl = "cengold://join";
  const androidAppStoreUrl =
    "https://play.google.com/store/apps/details?id=com.cengold.korda";
  const iosUrl = "cengold://join";
  const iosAppStoreUrl = "itms-appss://apps.apple.com/kr/app/id1484761981";

  const resultMoChk = moChk();
  if (resultMoChk !== "pc") {
    if (resultMoChk === "ios") {
      setTimeout(function () {
        window.location.href = iosAppStoreUrl;
      }, 1500);
      window.location.href = iosUrl;
    } else {
      setTimeout(function () {
        window.location.href = androidAppStoreUrl;
      }, 1500);
      window.location.href = androidUrl;
    }
  }
}

export function actionAppCengoldHana() {
  const androidAppStoreUrl =
    "OPEN_WEB#https://play.google.com/store/apps/details?id=com.cengold.korda";
  const iosAppStoreUrl =
    "OPEN_WEB#itms-appss://apps.apple.com/kr/app/id1484761981";

  const resultMoChk = moChk();
  if (resultMoChk !== "pc") {
    if (resultMoChk === "ios") {
      window.location.href = iosAppStoreUrl;
    } else {
      window.location.href = androidAppStoreUrl;
    }
  }
}

export function moChk() {
  let os = "";
  const mobile = /iphone|ipad|ipod|android/i.test(
    navigator.userAgent.toLowerCase()
  );
  if (mobile) {
    const userAgent = navigator.userAgent.toLowerCase();
    if (userAgent.search("android") > -1) {
      os = "android";
    } else if (
      userAgent.search("iphone") > -1 ||
      userAgent.search("ipod") > -1 ||
      userAgent.search("ipad") > -1
    ) {
      os = "ios";
    } else {
      os = "otehr";
    }
  } else {
    os = "pc";
  }
  return os;
}

export function finishAlert(callbackJS) {
  if (!window.wallet) {
    return;
  }
  window.wallet.openPopup(
    JSON.stringify({
      popupType: "basic",
      title: "",
      message: "비단 금투자 서비스를 종료하시겠습니까?",
      buttons: [
        { buttonText: "취소", callbackJS: "" },
        { buttonText: "종료", callbackJS: callbackJS },
      ],
    })
  );
}

export function webviewFinish() {
  if (!window.wallet) {
    return;
  }
  window.wallet.finish();
}

export const appendScript = (scriptToAppend, async) => {
  const script = document.createElement("script");
  script.src = scriptToAppend;
  script.async = async;
  document.body.appendChild(script);
};

export const hanaWebviewExit = () => {
  window.location.href = "WEB_EXIT_EVENT";
};

export const getIosVersion = function () {
  var agent = window.navigator.userAgent,
    start = agent.indexOf("OS ");
  if (
    (agent.indexOf("iPhone") > -1 || agent.indexOf("iPad") > -1) &&
    start > -1
  ) {
    return window.Number(agent.substr(start + 3, 3).replace("_", "."));
  }
  return 0;
};

export const encodingBase64 = (text) => {
  const wordArray = enc.Utf8.parse(text);
  return enc.Base64.stringify(wordArray);
};

export const decodingBase64 = (encoded) => {
  const parsedWordArray = enc.Base64.parse(encoded);
  return parsedWordArray.toString(enc.Utf8);
};

export const encryptSHA256 = (data, seq) => {
  const hashed = SHA256(SHA256(SHA256(seq)));
  const secKey = enc.Base64.stringify(hashed);
  return AES.encrypt(data, secKey).toString();
};
